// FlashProbabilityControls.js
import React, { memo } from 'react';

export const FlashProbabilityControls = memo(({ 
  useLogOdds, 
  setUseLogOdds 
}) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={useLogOdds}
        onChange={(e) => setUseLogOdds(e.target.checked)}
      />
      <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
      <span className="ml-3 text-sm font-medium text-gray-900">Show log odds</span>
    </label>
  );
});

FlashProbabilityControls.displayName = 'FlashProbabilityControls';